import { useEffect } from 'react'
import { flowRight } from 'lodash'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { footerWidgetSlotId, getSlot } from 'lib/alma/alma'

import './alma-footer.pcss'

const AlmaFooter = () => {
    useEffect(() => {
        getSlot(footerWidgetSlotId) // fetch Alma Footer widget
    }, [])

    return null
}

export default flowRight(
    withErrorBoundaryNoRender,
)(AlmaFooter)
